export default __webpack_public_path__ + "static/MediaContentSeven-44238c2adc7aef1db62baee6a191eae9.webp";